import { render, staticRenderFns } from "./messageconfig.vue?vue&type=template&id=e06dc280&"
import script from "./messageconfig.vue?vue&type=script&lang=ts&"
export * from "./messageconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "messageconfig.vue"
export default component.exports